export default __webpack_public_path__ + "static/media/p5.f3796b7a.jpg";